export const environment = {
  production: true,
  backendUrl: 'https://nekrolog.by/api',
  frontendUrl: 'https://nekrolog.by',
  captchaSiteKey: '6LdH-o4rAAAAAPl7nMtCWBcjJ3RAEq3NnlI5crCv',
};
